// src/services/profileService.ts
import { apiService } from './api';
import { config } from '@config/env';
import type { ProfileData, NotificationSettings, ProfileSavePayload } from '../types/profileTypes';

class ProfileService
{
  /**
   * Obtiene el perfil completo del usuario
   */
  async getProfile(): Promise<ProfileData>
  {
    return await apiService.get<ProfileData>('profile/Get');
  }

  /**
   * Obtiene la configuración de notificaciones del usuario
   */
  async getNotificationSettings(): Promise<NotificationSettings>
  {
    return await apiService.post<NotificationSettings>('Notification/GetNotificationSettings', {});
  }

  /**
   * Guarda el perfil del usuario con toda la configuración
   */
  async saveProfile(payload: ProfileSavePayload): Promise<any>
  {
    return await apiService.post<any>('profile/', payload);
  }

  /**
   * Sube la imagen de perfil del usuario
   */
  async uploadProfileImage(file: File): Promise<{ ImageName: string }>
  {
    const formData = new FormData();
    formData.append('file', file);

    const token =
      localStorage.getItem('C2_access_token') || localStorage.getItem('access_token') || '';
    const baseUrl = String(config.api.baseUrl || 'http://localhost/Corgee.Web/');
    const url = `${baseUrl.replace(/\/$/, '')}/api/profile/UploadProfileImage`;

    const response = await fetch(url, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: formData,
    });

    if (!response.ok)
    {
      throw new Error('Error al subir la imagen de perfil');
    }

    return response.json();
  }
}

export const profileService = new ProfileService();
